import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const PlusIconV2 = (props: PosIconProps) => {
  return (
    <SvgWrapper aria-label="plus-icon" {...props} viewBox="0 0 24 24">
      <path
        d="M12 5v14M5 12h14"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
